module.exports = __webpack_public_path__ + "img/title1.4d65c6a1.png";